<template>
    <div>
        <div class="wrapper">
            <div :class="leftClass">
                <slot name="left"></slot>
            </div>
            <div class="right" :class="rightClass">
                <slot name="right"></slot>
            </div>
        </div>
        <hr class="hr" />
    </div>
</template>

<script>
    export default {
        name: 'FormInlineBorderedGroup',
        props: {
            leftClass: [Array, Object, String],
            rightClass: [Array, Object, String],
        }
    }
</script>

<style scoped lang="scss">
    @import "~bootstrap/scss/_functions.scss";
    @import "~bootstrap/scss/_variables.scss";
    @import "~bootstrap/scss/mixins/_breakpoints.scss";

    .hr {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important;
    }

    .wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: .5rem;
    }

    @include media-breakpoint-down(md) {
        .wrapper {
            flex-direction: column;
            align-items: normal;
        }
    }

</style>
